<div class="card">
  <div class="card-header">Reimbursement Item History</div>
  <div class="card-body" mat-dialog-content>
    <div *ngIf="data" class="table-responsive mb-4">
      <table class="custom-table custom-table-default custom-table-border-row">
        <tbody>
          <tr *ngIf="!data.length">
            <td colspan="2">You will find item history here!</td>
          </tr>
          <tr *ngFor="let item of data; let i = index">
            <td><span class="text-muted whitespace-nowrap">{{item.PrevStatus||'New Request'}}</span></td>
            <td><i class="fa-thin fa-angles-right"></i></td>
            <td>
              <span [className]="i == 0 ? 'font-bold whitespace-nowrap' : 'text-muted whitespace-nowrap'">
                {{item.Status}}
              </span>
            </td>
            <td>
              <div class="text-end whitespace-nowrap">
                <span *ngIf="item.CreatedBy as by">
                  ({{Helper.users.formatUID(by.ID)}}) {{by.LastName}}, {{by.FirstName}} |
                </span>
                {{item.created_at|formatDateTime}}
              </div>
              <div class="text-end whitespace-nowrap">
                <span class="font-bold">Approved amount: </span>
                <span>{{(item.ApprovedAmount ?? 0)|currency:'₱ '}}</span>
              </div>
              <div class="text-end whitespace-nowrap">
                {{item.Remarks||'No Remarks'}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card-footer">
    <div class="form-submit">
      <button class="custom-button" mat-dialog-close>Close</button>
    </div>
  </div>
</div>